<template>
<div>
  <div class="row no-gutters py-2 mb-3 ml-md-3">
    <div class="col-md-10 col-sm-12" >
      <h4 class="atlhr-dashboard-title mt-10">
        My <span class="black-title">Approval</span>
        <span>
                    <a v-bind:href="$api_url">Dashboard</a>  / Leave and Attendance / My Approval
                </span>
      </h4>
    </div>
  </div>
 <!-- Abdullah responsive added mx-3  -->
  <div class="clearfix company-form-container leave-log mt-3 ml-md-3">
    <div class="p-3 employee-investment-wrapper">
      <div class="" >
        <div class="row no-gutters mb-3">
          <div class="col-md-12 leave-log-wrapper">
            <approver-waiting-approval></approver-waiting-approval>
          </div>
        </div>
      </div>
    </div>
  </div>
 <!-- Abdullah responsive added mx-3  -->
  <div v-if="approver[0]" class="clearfix company-form-container leave-log mt-3 ml-md-3">
    <div class="p-3 company-form-box-title">
      Leave Log
    </div>
    <div class="p-3 employee-investment-wrapper">
      <approver-leave-list-approver ></approver-leave-list-approver>
    </div>
  </div>

  <!-- Abdullah 20-05-26 added ml-3  -->
  <div v-if="approver[1]" class="clearfix company-form-container leave-log mt-3 ml-md-3">
    <div class="p-3 employee-investment-wrapper">
      <approver-employees-attendance-approver ></approver-employees-attendance-approver>
    </div>
  </div>
</div>
</template>

<script>
  export default {
    data(){
      return {
        approver: [false, false],
      }
    },
    methods: {
      checkIsApprover: function()
      {
        if(!this.checkNet()) return false;

        axios.get(this.$api_url+'/front/approver/check').then(function(response){
          this.approver = response.data;
        }.bind(this)).catch(function (error){this.serverError(error);});

      },
    },
    created() {
      this.checkIsApprover();
    }
  }
</script>
